import "./Home.css";

import GlobalOffices from "./GlobalPresence/GlobalPresence";
import Hero from "./Hero/Hero";
import Partners from "./Partners/Partners";
import Process from "./Process/Process";
import Projects from "./Projects/Projects";
import Stats from "./Stats/Stats";
import WhyChoose from "./WhyChoose/WhyChoose";
import CTA from "./CTA/CTA";
import Testimonials from "./Testimonials/Testimonials";
import Services from "./Services/Services";
import SeoAuthority from "./SeoAuthority/SeoAuthority";
import Industries from "./Industries/Industries";
import TechStack from "./TechStack/TechStack";
import HomeFAQ from "./FAQs/HomeFAQ";
import HomeInternalLinks from "./HomeInternalLinks/HomeInternalLinks";
import SeoAuditLaunchSection from "../components/SeoAuditLaunchSection";

const Home = () => {
  return (
    <main className="uniq-oglitz-home">
      <section className="uniq-oglitz-home__hero">
        <Hero />
      </section>
      <div className="uniq-oglitz-section-divider">
        <div className="uniq-oglitz-section-divider__content">
          {/* animated line */}
          <span className="uniq-oglitz-section-divider__line" />

          {/* main statement */}
          <p className="uniq-oglitz-section-divider__text">
            Oglitz Software is a leading
            <strong> Website, Web App & Software Development Company </strong>
            delivering scalable digital solutions worldwide.
          </p>

          {/* animated locations */}
          <div className="uniq-oglitz-section-divider__locations">
            <span>🇮🇳 India</span>
            <span className="dot" />
            <span>🇦🇪 Dubai</span>
            <span className="dot" />
            <span>🌍 Global</span>
          </div>

          {/* trust badges */}
          <div className="uniq-oglitz-section-divider__badges">
            <span>Web Applications</span>
            <span>Mobile Apps</span>
            <span>Enterprise Software</span>
            <span>Cloud Solutions</span>
          </div>
        </div>
      </div>
      <section className="uniq-oglitz-home__stats">
        <SeoAuditLaunchSection />
      </section>
      <section className="uniq-oglitz-home__SeoAuthority">
        <SeoAuthority />
      </section>
      <section className="uniq-oglitz-home__stats">
        <Stats />
      </section>

      <section className="uniq-oglitz-home__services">
        <Services />
      </section>
      <section className="uniq-oglitz-home__whychoose">
        <WhyChoose />
      </section>
      <section className="uniq-oglitz-home__partners">
        <Partners />
      </section>
      <section className="uniq-oglitz-home__Industries">
        <Industries />
      </section>
      <section className="uniq-oglitz-home__process">
        <Process />
      </section>
      <section className="uniq-oglitz-home__TechStack">
        <TechStack />
      </section>
      <section className="uniq-oglitz-home__projects">
        <Projects />
      </section>
      <section className="uniq-oglitz-home__testimonials">
        <Testimonials />
      </section>
      <section className="uniq-oglitz-home__global">
        <GlobalOffices />
      </section>
      <section className="uniq-oglitz-home__HomeFAQ">
        <HomeFAQ />
      </section>

      <section className="uniq-oglitz-home__HomeInternalLinks">
        <HomeInternalLinks />
      </section>

      <section className="uniq-oglitz-home__cta">
        <CTA />
      </section>
    </main>
  );
};

export default Home;
